<template>
  <div class="popup popup-club" id="clubRule">
    <div class="shorexDetail-title js-returnShorexBtn">
      <p>加入皇家游享荟</p>
      <a class="shorexDetail-returnButton external" @click="goBack()">
        <img
          src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightBlack.png"
        />
      </a>
    </div>

    <div class="club-wrap scroll-container">
      <div class="club-content">
        <div class="club-kv">
          <img
            src="https://resource.rcclchina.com.cn/memberCenter/mobile/signup/kv.jpg"
          />
          <div class="club-kv-btn js-signup-member" @click="onRegisterClick()">
            <img
              src="https://resource.rcclchina.com.cn/memberCenter/mobile/signup/signup-btn.jpg"
            />
          </div>
        </div>
        <div class="club-level">
          <div class="club-level-title">
            <img
              src="https://resource.rcclchina.com.cn/memberCenter/mobile/signup/title.png"
            />
          </div>
          <div class="club-level-items">
            <div class="row">
              <div class="club-level-item">
                <img
                  src="https://resource.rcclchina.com.cn/memberCenter/mobile/signup/lv1.png"
                />
              </div>
              <div class="club-level-item">
                <img
                  src="https://resource.rcclchina.com.cn/memberCenter/mobile/signup/lv2.png"
                />
              </div>
            </div>
            <div class="row">
              <div class="club-level-item">
                <img
                  src="https://resource.rcclchina.com.cn/memberCenter/mobile/signup/lv3.png"
                />
              </div>
              <div class="club-level-item">
                <img
                  src="https://resource.rcclchina.com.cn/memberCenter/mobile/signup/lv4.png"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="club-benefit">
          <div class="club-benefit-title">
            <img
              src="https://resource.rcclchina.com.cn/memberCenter/mobile/signup/benefit-title.png"
            />
          </div>
          <div class="club-benefit-items">
            <div class="row">
              <div class="club-benefit-item">
                <div class="club-benefit-item-image">
                  <img
                    src="https://resource.rcclchina.com.cn/memberCenter/mobile/signup/benefit-icon1-coupon.png"
                  />
                </div>
                <div class="club-benefit-item-text">
                  <span>会员专属优惠船票95折</span>
                </div>
              </div>
              <div class="club-benefit-item">
                <div class="club-benefit-item-image">
                  <img
                    src="https://resource.rcclchina.com.cn/memberCenter/mobile/signup/benefit-icon2-birthday.png"
                  />
                </div>
                <div class="club-benefit-item-text">
                  <span>生日礼券</span>
                </div>
              </div>
              <div class="club-benefit-item">
                <div class="club-benefit-item-image">
                  <img
                    src="https://resource.rcclchina.com.cn/memberCenter/mobile/signup/benefit-icon3-car.png"
                  />
                </div>
                <div class="club-benefit-item-text">
                  <span>专车抵用券</span>
                </div>
              </div>
              <div class="club-benefit-item">
                <div class="club-benefit-item-image">
                  <img
                    src="https://resource.rcclchina.com.cn/memberCenter/mobile/signup/benefit-icon4-reward.png"
                  />
                </div>
                <div class="club-benefit-item-text">
                  <span>卓越嘉奖</span>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="club-benefit-item">
                <div class="club-benefit-item-image">
                  <img
                    src="https://resource.rcclchina.com.cn/memberCenter/mobile/signup/benefit-icon5-ship.png"
                  />
                </div>
                <div class="club-benefit-item-text">
                  <span>尊享航线礼遇</span>
                </div>
              </div>
              <div class="club-benefit-item">
                <div class="club-benefit-item-image">
                  <img
                    src="https://resource.rcclchina.com.cn/memberCenter/mobile/signup/benefit-icon6-membership.png"
                  />
                </div>
                <div class="club-benefit-item-text">
                  <span>会员月双倍积分特权</span>
                </div>
              </div>
              <div class="club-benefit-item">
                <div class="club-benefit-item-image">
                  <img
                    src="https://resource.rcclchina.com.cn/memberCenter/mobile/signup/benefit-icon7-gift.png"
                  />
                </div>
                <div class="club-benefit-item-text">
                  <span>登船纪念品</span>
                </div>
              </div>
              <div class="club-benefit-item">
                <div class="club-benefit-item-image">
                  <img
                    src="https://resource.rcclchina.com.cn/memberCenter/mobile/signup/benefit-icon8-toy.png"
                  />
                </div>
                <div class="club-benefit-item-text">
                  <span>儿童或青少年登船礼</span>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="club-benefit-item">
                <div class="club-benefit-item-image">
                  <img
                    src="https://resource.rcclchina.com.cn/memberCenter/mobile/signup/benefit-icon9-campaign.png"
                  />
                </div>
                <div class="club-benefit-item-text">
                  <span>会员专属活动</span>
                </div>
              </div>
              <div class="club-benefit-item">
                <div class="club-benefit-item-image">
                  <img
                    src="https://resource.rcclchina.com.cn/memberCenter/mobile/signup/benefit-icon10-callcenter.png"
                  />
                </div>
                <div class="club-benefit-item-text">
                  <span>会员服务热线</span>
                </div>
              </div>
              <div class="club-benefit-item">
                <div class="club-benefit-item-image">
                  <img
                    src="https://resource.rcclchina.com.cn/memberCenter/mobile/signup/benefit-icon11-news.png"
                  />
                </div>
                <div class="club-benefit-item-text">
                  <span>会员特惠资讯</span>
                </div>
              </div>
              <div class="club-benefit-item">
                <div class="club-benefit-item-image">
                  <img
                    src="https://resource.rcclchina.com.cn/memberCenter/mobile/signup/benefit-icon12-website.png"
                  />
                </div>
                <div class="club-benefit-item-text">
                  <span>会员专属网站</span>
                </div>
              </div>
            </div>
          </div>

          <div class="club-benefit-tips">
            *以上权益据 “皇家游享荟” 会员等级不同而有差异
          </div>
        </div>
        <div
          class="club-bottom-btn js-signup-member"
          @click="onRegisterClick()"
        >
          <img
            src="https://resource.rcclchina.com.cn/memberCenter/mobile/signup/bottom-btn.jpg"
          />
        </div>
        <div class="mt15" style="text-align: center; font-size: 12px">
          <p>如需查看皇冠铁锚俱乐部相关信息，请登录后查看。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { gioTracking } from "@/utilities/tools";
export default {
  name: "SignUpReward",
  props: {
    isSignInPoint: {
      type: Boolean,
    },
  },
  mounted() {
    this.$store.commit("SET_PAGE_TITLE", "");
    const userToken = this.$store.state.user.userToken;
    if (!userToken || userToken.length == 0) {
      return this.$router.push({
        name: "Login",
        query: {
          returnUrl: location.href,
        },
      });
    }

    // 隐藏头尾
    this.$store.dispatch("HIDE_HEADER_BAR", {
      isHideHeader: true,
      isHideFooter: true,
    });
  },
  beforeDestroy() {
    this.$store.dispatch("HIDE_HEADER_BAR", {
      isHideHeader: false,
      isHideFooter: false,
    });
  },
  methods: {
    onRegisterClick() {
      const text = `<span>我已阅读<a href='${this.memberLink}' target='_blank'>《“皇家游享荟”项目细则》</a>并同意注册“皇家游享荟”会员及接受会员相关的优惠资讯及推送消息</span>`;
      this.$confirm.show(text, {
        confirmCallBack: () => {
          this.login();
        },
      });
    },
    async login() {
      this.$loading.show();
      const { success, errMsg } = await api.user.registeredMember({
        source: "mobile",
        isSignInPoint: this.isSignInPoint,
      });
      this.$loading.hide();
      if (!success) {
        console.error(errMsg);
        this.$alert.show(errMsg);
      } else {
        this.$loading.show();
        const { data } = await api.user.getUserInfo();
        if (data) {
          this.$store.commit("SET_USER_INFO", { userInfo: data });
        }
        this.$loading.hide();
				this.gioHandler();
        this.goBack(data.localRewardToken);
      }
    },
		gioHandler () {
			let sUrl = 'nil';
			const query = this.$router.currentRoute.query;
			if (query.returnUrl &&
        query.returnUrl.length > 0) {
					sUrl = sUrl = decodeURIComponent(query.returnUrl)
				}
			gioTracking('track', 'evt_Login', {
          isMkt: 'nil',
          isNewLR: '1',
          isNewLRMkt: '1',
          sUrl,
          regUrl: location.href,
          isQR:0
        })
		},
    goBack(localRewardToken) {
      const query = this.$router.currentRoute.query;
      let returnUrl = `${process.env.VUE_APP_REWARD_URL}/rewardpc`;
      if (
        query.returnUrl &&
        query.returnUrl.length > 0 &&
        query.returnUrl.toLowerCase().indexOf("signupreward") < 0
      ) {
        returnUrl = query.returnUrl;
      }

      if (localRewardToken) {
        if (localRewardToken) {
          if (returnUrl.indexOf("?") > 0) {
            returnUrl += `&token=${localRewardToken}`;
          } else {
            returnUrl += `?token=${localRewardToken}`;
          }
        }
      }
      location.href = returnUrl;
    },
  },
  computed: {
    memberLink() {
      return process.env.VUE_APP_BASE_URL + "/Rccl.UserCenter/RewardRule";
    },
    userInfo() {
      return this.$store.state.user.userInfo;
    },
  },
  watch: {
    userInfo() {
      if (this.userInfo && this.userInfo.userIdentity > 0) {
        return this.goBack(this.userInfo.localRewardToken);
      }
    },
  },
};
</script>

<style lang="less" scoped>
div#clubRule {
  display: block;
  transform: none;
  img {
    width: 100%;
    display: block;
  }
  .shorexDetail-title {
    padding: 15px 20px;
    background-color: #fff;
    overflow: hidden;
    text-align: center;
    margin-bottom: 10px;
    position: fixed;
    width: 100%;
    z-index: 10;
    > p {
      
      font-size: 14px;
      color: #333333;
      letter-spacing: 1px;
      text-align: center;
      margin: 0;
    }
    .shorexDetail-returnButton {
      width: 30px;
      position: absolute;
      top: 15px;
      left: 20px;
      text-align: left;
      > img {
        width: 33%;
      }
    }
  }
  .club-wrap {
    height: 100%;
    overflow-y: scroll;
    padding-bottom: 80px;
    .club-content {
      margin-top: 51px;
      .club-kv {
        position: relative;
        width: 100%;
      }
      .club-kv-btn {
        position: absolute;
        width: 246px;
        left: 64px;
        bottom: -24px;
        z-index: 1;
      }
      .club-level {
        position: relative;
        margin-top: 50px;
        .club-level-title {
          width: 262px;
          margin: auto;
        }
        .club-level-items {
          position: relative;
          margin-top: 16px;
          .row {
            margin: 0px 10px;
          }
          .row:first-child {
            margin-bottom: 4px;
          }
          .club-level-item {
            width: 175px;
            float: left;
          }
          .club-level-item:first-child {
            margin-right: 4px;
          }
        }
      }
      .club-benefit {
        position: relative;
        margin-top: 30px;
        .club-benefit-title {
          width: 262px;
          margin: auto;
        }
        .club-benefit-items {
          position: relative;
          margin-top: 20px;
          .row {
            margin: 0px 20px 10px 20px;
          }
          .row::after {
            content: "";
            clear: both;
          }
          .club-benefit-item {
            position: relative;
            float: left;
            width: 60px;
            margin-left: 30px;
            text-align: center;
            .club-benefit-item-image {
              width: 58px;
              margin: auto;
            }
            .club-benefit-item-text {
              font-size: 10px;
              text-align: center;
              color: #282b2c;
              margin-top: 5px;
            }
          }
          .club-benefit-item:first-child {
            margin-left: 0px;
          }
        }
        .club-benefit-tips {
          position: relative;
          right: 20px;
          color: #747d80;
          font-size: 9px;
          text-align: right;
          margin-top: 20px;
        }
      }
      .club-bottom-btn {
        position: relative;
        width: 246px;
        margin: 21px auto 0 auto;
      }
    }
  }
}
</style>